var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('price-list-table',{attrs:{"item-id":_vm.itemId}}),_c('companies-price-list-table',{attrs:{"item-id":Number(_vm.itemId)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }